import { render, staticRenderFns } from "./ModalMetadatos.vue?vue&type=template&id=7f197d48"
import script from "./ModalMetadatos.vue?vue&type=script&lang=js"
export * from "./ModalMetadatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f197d48')) {
      api.createRecord('7f197d48', component.options)
    } else {
      api.reload('7f197d48', component.options)
    }
    module.hot.accept("./ModalMetadatos.vue?vue&type=template&id=7f197d48", function () {
      api.rerender('7f197d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/portal/buscador/ModalMetadatos.vue"
export default component.exports